import React, { useState } from 'react';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';
import { styles } from './OldApplianceRemovalSection.css';
import { styles as commonStyles } from './installProductService.css';
import { OldApplianceRemovalSectionProps } from './types';
import { formatMoney } from '@jbhi-fi/lanyard-ui/global/utils';
import Spinner from '@jbhi-fi/lanyard-ui/components/Spinner';
import RadioCard from '@jbhi-fi/lanyard-ui/components/RadioCard';

const OPTION = {
  REMOVE: 'remove',
  NO: 'no',
};

export const OldApplianceRemovalSection = ({
  applianceLabel,
  price,
  isSelected,
  isDisabled,
  onSelect,
  onDeselect,
  isLoading,
  isMobile,
}: OldApplianceRemovalSectionProps) => {
  const [hasUserSelected, setHasUserSelected] = useState(false);

  const handleClick = (value: string) => {
    if (isDisabled) return;
    setHasUserSelected(true);
    if (value === OPTION.REMOVE) {
      onSelect?.();
      return;
    }
    onDeselect?.();
  };

  const choices = [
    {
      id: 'remove_old_appliance',
      heading: `Remove old ${applianceLabel}`,
      message: `${formatMoney(price)}`,
      name: OPTION.REMOVE,
      value: OPTION.REMOVE,
      className: styles.option({ isSelected: isSelected && !isLoading && hasUserSelected }),
      checked: isSelected && hasUserSelected,
    },
    {
      id: 'keep_old_appliance',
      heading: 'No thanks',
      message: undefined,
      name: OPTION.NO,
      value: OPTION.NO,
      className: styles.option({ isSelected: !isSelected && !isLoading && hasUserSelected }),
      checked: !isSelected && hasUserSelected,
    },
  ];

  return (
    <section className={styles.section}>
      <CalloutFont as="h3" className={commonStyles.accessoryHeading}>
        Need your old {applianceLabel} removed?
      </CalloutFont>

      <p className={styles.description({ mobile: isMobile })}>
        We can take old {applianceLabel}s of a similar type and size away for e-waste recycling.
      </p>

      <div className={styles.options}>
        {choices.map(choice => (
          <RadioCard
            key={choice.id}
            id={choice.id}
            name={choice.name}
            value={choice.value}
            checked={choice.checked}
            onClick={() => handleClick(choice.value)}
            className={choice.className}
            showRadioButton={false}
          >
            {isLoading && choice.checked ? (
              <div className={styles.optionSpinnerWrapper}>
                <Spinner />
              </div>
            ) : (
              <div className={styles.optionContentWrapper}>
                {choice.heading ? (
                  <div className={styles.optionHeading({ isSelected: choice.checked })}>{choice.heading}</div>
                ) : null}
                {choice.message ? (
                  <div className={styles.optionMessage({ isSelected: choice.checked })}>{choice.message}</div>
                ) : null}
              </div>
            )}
          </RadioCard>
        ))}
      </div>
    </section>
  );
};
